import { render, staticRenderFns } from "./BaseEventPicker.vue?vue&type=template&id=3bf2a744&"
import script from "./BaseEventPicker.vue?vue&type=script&lang=js&"
export * from "./BaseEventPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf2a744')) {
      api.createRecord('3bf2a744', component.options)
    } else {
      api.reload('3bf2a744', component.options)
    }
    module.hot.accept("./BaseEventPicker.vue?vue&type=template&id=3bf2a744&", function () {
      api.rerender('3bf2a744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseEventPicker.vue"
export default component.exports